import { createReducer, on } from '@ngrx/store';
import { uniqBy } from 'lodash-es';
import { ConversationNodeData, ConversationNodeLink, ConversationNodeQuery } from './types';
import {
  ConversationNodeLoadAction,
  ConversationNodeLoadErroredAction,
  ConversationNodeLoadSucceededAction,
  FocusedConversationNodeLoadAction,
  FocusedConversationNodeLoadErroredAction,
  FocusedConversationNodeLoadSucceededAction,
} from './conversation-node.actions';
import { ConversationNodeApiError } from './conversation-node.errors';
import { defaultConversationNodeColors } from '../../shared/constants';

export interface ConversationNodeState {
  colors: { [key: string]: string };
  filter: ConversationNodeQuery;
  seriesData: ConversationNodeData[];
  seriesLinks: ConversationNodeLink[];
  loading: boolean;
  apiError: ConversationNodeApiError;

  focusedNodeSeriesData: ConversationNodeData[];
  focusedNodeSeriesLinks: ConversationNodeLink[];
  focusedNodeLoading: boolean;
  focusedNodeApiError: ConversationNodeApiError;
}

export const initialState: ConversationNodeState = {
  colors: {},
  filter: null,
  seriesData: [],
  seriesLinks: [],
  loading: false,
  apiError: null,
  focusedNodeSeriesData: [],
  focusedNodeSeriesLinks: [],
  focusedNodeLoading: false,
  focusedNodeApiError: null,
};

export function parseColorFromSeriesData(seriesData: ConversationNodeData[]) {
  return uniqBy(seriesData, 'category')
    .map((item) => item.category)
    .reduce(
      (acc, category, index) => ({
        ...acc,
        [category]: `${defaultConversationNodeColors[index]}`,
      }),
      {},
    );
}

export const conversationNodeReducer = createReducer(
  initialState,
  on(ConversationNodeLoadAction, (state, { filter }) => ({
    ...state,
    ...initialState,
    filter,
    loading: true,
  })),
  on(ConversationNodeLoadSucceededAction, (state, { seriesLinks, seriesData }) => ({
    ...state,
    colors: parseColorFromSeriesData(seriesData),
    seriesData,
    seriesLinks,
    loading: false,
    apiError: null,
  })),
  on(ConversationNodeLoadErroredAction, (state, { apiError }) => ({
    ...state,
    apiError,
    loading: false,
    seriesData: [],
    seriesLinks: [],
  })),
  on(FocusedConversationNodeLoadAction, (state, { focusedName }) => ({
    ...state,
    filter: { ...state.filter, focusedName },
    focusedNodeSeriesData: [],
    focusedNodeSeriesLinks: [],
    focusedNodeLoading: true,
    focusedNodeApiError: null,
  })),
  on(FocusedConversationNodeLoadSucceededAction, (state, { seriesLinks, seriesData }) => ({
    ...state,
    focusedNodeApiError: null,
    focusedNodeLoading: false,
    focusedNodeSeriesData: seriesData,
    focusedNodeSeriesLinks: seriesLinks,
  })),
  on(FocusedConversationNodeLoadErroredAction, (state, { apiError }) => ({
    ...state,
    focusedNodeLoading: false,
    focusedNodeSeriesData: [],
    focusedNodeSeriesLinks: [],
    focusedNodeApiError: apiError,
  })),
);
